module.exports = __webpack_public_path__ + "media/images/version_merge/appstore_soon_btn-29761196e6de11a04dcf7b4b19be4aae.png";